import { IState } from 'legacy/lut/store'

export const selectMarketYoyGrowthExpectationState = (state: IState) =>
  state.partner360.marketYoyGrowthExpectation
